import { inject, Injectable } from '@angular/core';
import dayjs from 'dayjs';
import { formatDate, formatDateWithoutUtcCasting } from '@ireckonu/shared-ui';

import { ConfigurationQueryService } from './configuration-query.service';

@Injectable({
  providedIn: 'root',
})
export class TimeZoneService {
  private readonly configService = inject(ConfigurationQueryService);

  get dateTimeFormat(): string {
    return `${this.dateFormat} ${this.timeFormat}`;
  }

  get fullTimeFormat(): string {
    return 'HH:mm:ss';
  }

  get dateFormat(): string {
    return this.configService.dateFormat() ?? 'DD/MM/YYYY';
  }

  private get timeFormat(): string {
    return 'HH:mm';
  }

  getUtcDateTimeFormatted(rawDate: Date | string): string {
    return `${formatDate(
      this.addTimezoneIfNeeded(rawDate),
      this.dateTimeFormat,
    )} UTC`;
  }

  getDateTimeFormatted(rawDate: Date | string): string {
    return `${formatDateWithoutUtcCasting(rawDate, this.dateTimeFormat)} UTC`;
  }

  getFormattedDate(rawDate: Date): string {
    return `${formatDateWithoutUtcCasting(rawDate, this.dateFormat)}`;
  }

  getFormattedDefaultDate(rawDate: Date): string {
    return `${formatDateWithoutUtcCasting(rawDate, 'DD/MM/YYYY')}`;
  }

  getFormattedFullTime(rawDate: Date | string): string {
    return `${dayjs(rawDate).format(this.fullTimeFormat)}`;
  }

  // if there is no timezone consider it as UTC
  private addTimezoneIfNeeded(rawDate: Date | string): string | Date {
    return typeof rawDate === 'string' &&
      !rawDate.includes('Z') &&
      !rawDate.includes('+')
      ? `${rawDate}Z`
      : rawDate;
  }
}
